import { Platform, PlatformCommandInteraction, Platforms } from "./PlatformCommandInteraction";

export class CommandEntry
{
  name:string;
  condition:string;
  platformInteractions:PlatformCommandInteraction[] = [];

  getForPlatform( platform:Platform )
  {
    let command = this.platformInteractions.find( ( p )=> p.platform === platform );

    if ( command )
    {
      return command;
    }

    let isDesktopPlatform = Platforms.isDesktop( platform );

    if ( ! isDesktopPlatform )
    {
      return null;
    }

    return this.platformInteractions.find( ( p )=> p.platform === Platforms.Desktop );
  }
}